<script>
    import TableList from './TableList.svelte';

    let tableData = {
        details: { 
            titleList: 'Products' ,
            titleEdit: 'Product' ,
            create: true,
            delete: true,
            edit: true,
            hasMediaFiles: true,
            mediaFileType: 'image/*',            
            sortby: 'name',
        },
        fields: [
            { 
                key: 'name', 
                label: 'Name', 
                type: 'text',
                editable: true, 
                sortable: true 
            },
            { 
                key: 'description', 
                label: 'Description', 
                type: 'text',
                editable: true, 
                sortable: true,
                sortType: 'numeric' 
            },
            { 
                key: 'meta_data', 
                label: 'Tokens', 
                type: 'text',
                editable: true, 
                sortable: true,
                sortType: 'numeric' 
            },
            { 
                key: 'unit_price_inc_tax', 
                label: 'Price Inc Tax', 
                type: 'text',
                editable: true, 
                sortable: true 
            }
        ]
    };

</script>

<TableList modelName="item" {tableData} />
